var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bcf616822b034ca04cb6135f93da2e8d46941eb0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["eth-dapp-v2@staderlabs"]={id:"bcf616822b034ca04cb6135f93da2e8d46941eb0"};
      